// extracted by mini-css-extract-plugin
module.exports = {"base":"_1pj7JwPJBDKXYr8XLJkaNT"};